module.exports = __webpack_public_path__ + "media/images/hybrid_raid_5_disks-48ed54f1dc0aec4d9f4f695529296906.svg";